import classNames from 'classnames'
import { NEW_PASSWORD_PATH } from 'data/auth/utils'
import LinkIcon from 'mdi-react/LinkIcon'
import React from 'react'
import { useMutation } from 'react-query'
import { makeStyles } from 'tss-react/mui'
import { QueryStatus } from 'utils-next/api'
import { v4 as uuidv4 } from 'uuid'

import { CircularProgress, IconButton, Theme } from '@mui/material'

import { getApiUserHandlers, User } from '../../../../entities-next/user'

export type CopyDashboardURLProps = {
  className?: string
  userId: User['id']
  small?: boolean
}

export function CopyDashboardURL({ className, userId, small }: CopyDashboardURLProps) {
  const { classes } = useStyles()
  const { status, mutate } = useMutation(apiGetDashboardUrl)

  return (
    <div className={classNames(className, classes.iconContainer)}>
      {status === QueryStatus.loading ? (
        <CircularProgress size={16} color="secondary" />
      ) : (
        <IconButton
          className={classNames(small && classes.noPadding, classes.copyButton)}
          onClick={() => mutate(userId)}
        >
          <LinkIcon className={classes.iconInButton} />
        </IconButton>
      )}
    </div>
  )
}

async function apiGetDashboardUrl(userId: User['id']) {
  const { apiGetUser, apiUpdateUser } = getApiUserHandlers()
  const user = await apiGetUser(userId)

  // The only purpose of that token it 'seem' secure, currently is not checking in any way in the back end
  const token = uuidv4()
  const updatedUser = await apiUpdateUser(user.id, { ...user, passwordResetToken: token })
  const dashboardUrl = generateDashboardURL(updatedUser.email, token)
  navigator.clipboard.writeText(dashboardUrl)
}

function generateDashboardURL(email = '', token: string) {
  return `https://app.foundernest.com${NEW_PASSWORD_PATH}?email=${encodeURIComponent(email)}&token=${token}`
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  iconContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: spacing(4),
    height: spacing(4),
  },
  copyButton: {
    width: '100%',
    height: '100%',
  },
  noPadding: {
    padding: spacing(0.75),
  },
  iconInButton: {
    width: '100%',
    height: '100%',
  },
}))
